import { render, staticRenderFns } from "./EditIotDevice.vue?vue&type=template&id=56b5c70c"
import script from "./EditIotDevice.vue?vue&type=script&lang=js"
export * from "./EditIotDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports